import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Settings2 } from "lucide-react";
import { getCurrentUser } from "aws-amplify/auth";
import { Hub } from "aws-amplify/utils";
import "./ManageMatchLink.css";

export default function ManageMatchLink({ match, family }) {
  const [userId, setUserId] = useState(null);
  const ownerId = match?.ownerUserId;

  useEffect(() => {
    let active = true;
    let revision = 0;
    async function refresh() {
      const request = ++revision;
      setUserId(null);
      try {
        const user = await getCurrentUser();
        if (active && request === revision) setUserId(user.userId || null);
      } catch { /* Guests and expired sessions have no management shortcut. */ }
    }
    if (!ownerId) return undefined;
    const stop = Hub.listen("auth", ({ payload }) => {
      if (payload.event === "signedOut" || payload.event === "tokenRefresh_failure") {
        ++revision;
        setUserId(null);
      } else if (payload.event === "signedIn") refresh();
    });
    refresh();
    return () => { active = false; ++revision; stop(); };
  }, [ownerId]);

  if (!userId || !ownerId || userId !== ownerId || !match?.matchId || !["arc", "bullseye"].includes(family)) return null;
  return <Link className="match-owner-link" to={`/matches/manage/${family}/${encodeURIComponent(match.matchId)}`}>
    <Settings2 size={17} aria-hidden="true" />Manage this match
  </Link>;
}
